export const MEDALLIA_FORM_ID = process.env.NEXT_PUBLIC_MEDALLIA_FORM_ID
